import { createApiAction, restApiActions } from 'redux/redux-actions';
import { STORE_NOTIFICATIONS_LIST, APP_NOTIFICATIONS_LIST, MARK_NOTIFICATION_AS_READ } from 'redux/constants';
import restApis from '../restApis';

const notificationsApi = restApis('notifications');
const markAsReadApi = restApis('notifications', 'markasread');

export const getNotifications = (type) => {
  switch (type) {
    case 'store':
      return createApiAction(
        STORE_NOTIFICATIONS_LIST, notificationsApi.list,
      )({ type });
    case 'app':
      return createApiAction(
        APP_NOTIFICATIONS_LIST, notificationsApi.list,
      )({ type });
    default:
      break;
  }
  return {};
};

export const markNotificationAsRead = createApiAction(
  MARK_NOTIFICATION_AS_READ,
  markAsReadApi.create,
  {
    title: 'Success',
    detail: 'Notifications are marked as read successfully.',
  },
);

export default restApiActions('notifications');
